import React from 'react';
import MasterPage from 'components/MasterPage';
import { useState } from 'react';
import { Container, Form, Row, Col, Card, Button, Modal, Spinner, Tabs, Tab } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Redirect } from 'react-router';
import { api } from 'services';
import { WidgetsOutlined, ArrowBackIos } from '@material-ui/icons';
import { Link } from 'react-router-dom';
import { Phone, CNPJ } from 'helpers/Input';
import { Currency, currencyReverse} from 'helpers/Currency';
import './style.css';
import { channel } from 'redux-saga';

function CallRecord() {
  const model = [
    {name:'channel',required:true},
    {name:'name',required:true},
    {name:'email',required:true},
    {name:'phone',required:true},

    {name:'company_name',required:true},
    {name:'company_phone',required:true},
    {name:'name_technical_contact',required:true},

    {name:'service_provider',required:true},
    {name:'call_number',required:true},
    {name:'opening_date',required:true},
    {name:'schedule',required:true},
    {name:'service_name',required:true},

    {name:'description',required:true},
  ];

  const [form, setForm] = useState({type:1});
  const [isLoad, setLoad] = useState(false)
  const [end, setEnd] = useState({isEnd:false, isError:false})

  const handleSubmit = (e,form) => {
    e.preventDefault();
    api
      .post('technical-support', form)
      .then(() => {
      })
      .catch(()=>{
      });
  };

  return (
    <Form noValidate className="mt-4" onSubmit={(e)=>handleSubmit(e,form)}>
      <Form.Row>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>Canal Parceiro</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, channel: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>Nome</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) => setForm({ ...form, name: e.target.value })}
          />
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>E-mail</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, email: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>Telefone</Form.Label>
          <Phone
            onChange={(e) =>
              setForm({ ...form, phone: e.target.value })
            }
          />
        </Form.Group>
      </Form.Row>
      <Row className="mt-4">
        <Col md="12">
          <h6 className="title-dashboard">Dados do Cliente Final</h6>
        </Col>
        <Col md="12">
          <hr className="line"></hr>
        </Col>
      </Row>
      <Form.Row>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>Razão Social</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, company_name: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>Linha Principal</Form.Label>
          <Phone
            onChange={(e) =>
              setForm({ ...form, company_phone: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>Nome Contato Técnico</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, name_technical_contact: e.target.value })
            }
          />
        </Form.Group>
      </Form.Row>
      <Row className="mt-4">
        <Col md="12">
          <h6 className="title-dashboard">Dados do chamado técnico</h6>
        </Col>
        <Col md="12">
          <hr className="line"></hr>
        </Col>
      </Row>
      <Form.Row>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>N° do Chamado</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, call_number: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>Data de Abertura</Form.Label>
          <div className="">
            <DatePicker
              className="form-control"
              dateFormat="dd/MM/yyyy"
              selected={form.opening_date}
              locale="pt-BR"
              onChange={(date) =>
                setForm({ ...form, opening_date: date })
              }
              onChangeRaw={(e) => {
                e.preventDefault();
              }}
            />
          </div>
        </Form.Group>
        <Form.Group as={Col} xs="12" md="4">
          <Form.Label>Horário</Form.Label>
          <div className="">
            <DatePicker
              className="form-control"
              selected={form.schedule}
              locale="pt-BR"
              onChange={(date) => setForm({ ...form, schedule: date })}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
              onChangeRaw={(e) => {
                e.preventDefault();
              }}
            />
          </div>
        </Form.Group>
      </Form.Row>
      <Form.Row>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>Provedor de Serviço</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, service_provider: e.target.value })
            }
          />
        </Form.Group>
        <Form.Group as={Col} xs="12" md="6">
          <Form.Label>Nome do serviço</Form.Label>
          <Form.Control
            required
            type="text"
            onChange={(e) =>
              setForm({ ...form, service_name: e.target.value })
            }
          />
        </Form.Group>
      </Form.Row>
      <Row className="mt-4">
        <Col md="12">
          <h6 className="title-dashboard">Breve Descritivo</h6>
        </Col>
        <Col md="12">
          <hr className="line"></hr>
        </Col>
      </Row>
      <Form.Group as={Col} xs="12" md="12">
        <Form.Control
          required
          as="textarea"
          onChange={(e) =>
            setForm({ ...form, description: e.target.value })
          }
        />
      </Form.Group>
      
      
      <Form.Row className="col-12 pr-0">
        <Form.Group as={Col}>
          <Button block variant="primary" type="submit" disabled={isLoad}>
            Enviar
            </Button>
        </Form.Group>
      </Form.Row>
    </Form>
    );
}

export default CallRecord;
